












































































































import Vue from 'vue'

export default Vue.extend({
  name: 'ScreenshotExamplesModal',

  props: {
    modalVisible: {
      type: Boolean,
      required: true,
    },
  },
})
